import { render, staticRenderFns } from "./KeluhanInternal.vue?vue&type=template&id=3d44c719&scoped=true&"
import script from "./KeluhanInternal.vue?vue&type=script&lang=js&"
export * from "./KeluhanInternal.vue?vue&type=script&lang=js&"
import style0 from "./KeluhanInternal.vue?vue&type=style&index=0&id=3d44c719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d44c719",
  null
  
)

export default component.exports